module.exports = __webpack_public_path__ + "img/service-fenan1.bdad3860.svg";